import { render, staticRenderFns } from "./QuoteDetails.vue?vue&type=template&id=b6bddb5c&scoped=true&"
import script from "./QuoteDetails.vue?vue&type=script&lang=js&"
export * from "./QuoteDetails.vue?vue&type=script&lang=js&"
import style0 from "../assets/scss/projectForm.scss?vue&type=style&index=0&id=b6bddb5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6bddb5c",
  null
  
)

export default component.exports